<template>
  <form>
    <label v-if="bottledByChar > 0" for="bottledBy-personalisation-input" class="personalisation-overlay-details--label">bottled by</label>
    <div class="form-input">
      <input
        class="sensitive"
        autofocus
        :disabled="adding"
        ref="bottledByInput"
        id="bottledBy-personalisation-input"
        placeholder="bottled by"
        :maxlength="bottledByCharMax"
        v-model='bottledByInput'
        type="text"
      />
      <span :class="bottledByChar > bottledByCharMax ? 'count-over' : 'count'" >{{bottledByChar}}/{{bottledByCharMax}}</span>
    </div>
    <form @submit.prevent>
      <button style="width: 100%" :class="adding || bottledByChar === 0 ? 'preview-button--disabled' : 'preview-button'" @click="addToCart">Add to cart</button>
    </form>
  </form>
</template>
<script>


import { mapGetters } from "vuex";
import { isEmpty } from "lodash-es";
import events from "Assets/js/components/events";
export default {
  name: "BottledByOnly",
  props: {
    adding: Boolean,
    variantId: String,
    productId: String,
    setActive: Function,
    setAdding: Function,
    b2bCart: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      bottledByInput: '',
      bottledByCharMax: 10,
    }
  },
  beforeMount() {
    // For B2B: init fields
    if (!isEmpty(this.b2bCart) && this.b2bCart.bottledByMessage) {
      this.bottledByInput = this.b2bCart.bottledByMessage.bottledBy;
    }
  },
  computed: {
    ...mapGetters([
      'cartInstance'
    ]),
    bottledByChar(){
      return this.bottledByInput.length;
    }
  },
  methods: {
    addToCart() {
      if(this.bottledByInput > this.bottledByCharMax){
        return;
      }
      this.setAdding(true);
      const message = {
        bottledBy: this.bottledByInput
      };

      if (!isEmpty(this.b2bCart)) {
        this.cartInstance.updateB2BCartWithBottledByOnly(
          this.b2bCart.lineItemId,
          this.b2bCart.lineItemAttributes,
          message,
          (responseData) => {
            if (responseData.status === 200) {
              this.setActive(false);
              this.setAdding(false);
            }

            // Trigger cart change event
            events.cartChange(this.cartInstance.getCart());

            // Trigger callback
            if (typeof this.b2bCart.callback === "function") {
              this.b2bCart.callback(message);
            }
          });
      } else {
        this.cartInstance.addToCartWithBottledByOnly(this.variantId, message, this.productId, (responseData) => {
          if (responseData.status === 200) {
            this.setActive(false);
            this.setAdding(false);
          }

          // Trigger cart change event
          events.cartChange(this.cartInstance.getCart());
        });
      }
    },
  },

}
</script>
